import { chooseDBTranslation } from 'utils/translations'
import { Paragraph, TextRun } from 'docx'
import { CVData } from 'types/printInterfaces'
import { itemHeading, itemHeadingTabStops, itemParagraphSpacing } from './itemHeading'
import { fontSize } from './pageLayout'
import { convertToDisplayDate } from 'utils/utils'
import { IHideSetting } from 'types/layoutInterfaces'
import { isDetailHidden } from '../hideSettings'
import { i18n as i18nType, TFunction } from 'i18next'

/**
 * Generate the employment section of the CV.
 *
 * @param {object} i18n - The internationalization object.
 * @param {CVData} data - The data for the CV.
 * @param {object} t - The translation object.
 * @param {IHideSetting | undefined} hideSetting - The hide setting for the CV.
 * @return {Paragraph[]} An array of Paragraph objects representing the employment section.
 * @notExported
 */
const employment = (i18n: i18nType, data: CVData, t: TFunction, hideSetting: IHideSetting | undefined): Paragraph[] => {
  // return employment section

  const employments: Paragraph[] = []

  for (let i = 0; i < data.employments.length; i++) {
    const employment = data.employments[i]
    let date = ''
    if (employment.startDate) {
      date += `${convertToDisplayDate(employment.startDate, employment.dateResolution)} - `
    }
    if (employment.endDate) {
      date += `${convertToDisplayDate(employment.endDate, employment.dateResolution)}`
    }

    let roles = ''
    if (employment.EmployerRoles) {
      employment.EmployerRoles.forEach(role => {
        roles += chooseDBTranslation(i18n, role.Skill).name + '   '
      })
    }

    employments.push(
      new Paragraph({
        keepLines: true,
        style: 'CaleoNormal',
        tabStops: itemHeadingTabStops,
        spacing: itemParagraphSpacing,
        children: [
          ...itemHeading(
            !isDetailHidden(hideSetting, 'name') && employment ? chooseDBTranslation(i18n, employment).name : '',
            !isDetailHidden(hideSetting, 'date') && employment ? date : ''
          ),
          new TextRun({
            text: !isDetailHidden(hideSetting, 'primaryRole') && employment ? `${t('print.project.role')}: ` : '',
            bold: true,
            break: 1,
          }),
          new TextRun({
            text:
              !isDetailHidden(hideSetting, 'primaryRole') && employment
                ? chooseDBTranslation(i18n, employment).primaryRole
                : '',
          }),
          ...(!isDetailHidden(hideSetting, 'roles') && roles.length > 0
            ? [
                new TextRun({
                  text: `${t('print.employment.roles')}: `,
                  bold: true,
                  break: 1,
                }),
                new TextRun({
                  text: roles,
                }),
              ]
            : []),
          new TextRun({
            text:
              !isDetailHidden(hideSetting, 'description') && employment
                ? chooseDBTranslation(i18n, employment).description
                : '',
            size: fontSize.small,
            break: 1,
          }),
        ],
      })
    )
  }

  return employments
}

export default employment
